// PlayButtonExtraTime.js
var PlayButtonExtraTime = pc.createScript('playButtonExtraTime');

// initialize code called once per entity
PlayButtonExtraTime.prototype.initialize = function() {

    PlayButtonExtraTime.instance = this;
    
    this.entity.button.once('click', function(event){ //Play butonu dinlemeye baslar.
            playExtraTime = true;
            //LevelLoader.instance.LoadLevel("Game", "ExtraTimePlay");
            if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "PlayButtonExtraTime:Click", 1);}
            LevelLoader.instance.LoadLevel("LoadingScene", "ExtraTimePlay");
    },this);
};


